import axios from 'axios';
import { AuthGS, CheckWorkerValid, ClDonneesPresta, Cl_PrestaEmployeeAccess, Cl_PrestaEmployerAccess, Cl_PrestaImport, PrestaDataCrypted, PrestaDataDigit, PrestaEmployerAccess } from '../Model/PrestaData';

export const CheckPrestaAccessEmployer = async (serviceUrl : string, employerNum : number) => {

  var prestaAccessIn = new PrestaEmployerAccess();
  prestaAccessIn.noEmployeur = employerNum;

  try {
    var url = serviceUrl + 'Presta/CheckEmplAccess';

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
      timeout: 0
    };
    const { data } = await axios.post<Cl_PrestaEmployerAccess>(url, prestaAccessIn, requestOptions);
    return data;
  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      if(error.response?.status == 401)
      {
        return "PRESTA_ERROR_UNAUTHORIZED";
      }
      else
      {
        return error.message;
      }
    }
    else {
      return 'Presta Import Error';
    }
  }
}

export const CheckPrestaEmployee = async (serviceUrl : string, employerNum : number, employeeNum : number) => {
  var prestaEmployeeIn = new CheckWorkerValid();
  prestaEmployeeIn.noEmployeur = employerNum;
  prestaEmployeeIn.noTravailleur = employeeNum;

  try {
    var url = serviceUrl + 'Presta/CheckWorkerValid';

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
      timeout: 0
    };

    const { data } = await axios.post<Cl_PrestaEmployeeAccess>(url, prestaEmployeeIn, requestOptions);
    return data;
  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      if(error.response?.status == 401)
      {
        return "PRESTA_ERROR_UNAUTHORIZED";
      }
      else
      {
        return error.message;
      }
    }
    else {
      return 'Presta Import Error';
    }
  }
};

export const GetPrestaData = async (serviceUrl : string, employerNum : number, employeeNum : number) => {
  var prestaDataIn = new PrestaDataDigit();
  prestaDataIn.noEmployeur = employerNum;
  prestaDataIn.noTravailleur = employeeNum;

  try {
    var url = serviceUrl + 'Presta/PrestaData';

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
      timeout: 0
    };

    const { data } = await axios.post<Cl_PrestaImport>(url, prestaDataIn, requestOptions);
    return data;

  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      if(error.response?.status == 401)
      {
        return "PRESTA_ERROR_UNAUTHORIZED";
      }
      else
      {
        return error.message;
      }
    }
    else {
      return 'Presta Import Error';
    }
  }
}

export const GetPrestaDataCrypted = async (serviceUrl : string, employerCrypted : string, employeeCrypted : string) => {
  var prestaDataIn = new PrestaDataCrypted();
  prestaDataIn.noEmployeur = employerCrypted;
  prestaDataIn.noTravailleur = employeeCrypted;

  try {
    var url = serviceUrl + 'Presta/PrestaDataDecode';

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
      timeout: 0
    };

    const { data } = await axios.post<Cl_PrestaImport>(url, prestaDataIn, requestOptions);
    return data;

  }
  catch (error) {

    if (axios.isAxiosError(error)) {
      if(error.response?.status == 401)
      {
        return "PRESTA_ERROR_UNAUTHORIZED";
      }
      else
      {
        return error.message;
      }
    }
    else {
      return 'Presta Import Error';
    }
  }
}


export const InitPresta = async (serviceUrl : string) => {
  try {
    var url = serviceUrl + 'Presta/Get';

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
      timeout: 0
    };

    const { data } = await axios.get<AuthGS>(url, requestOptions);
    return data;
  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      if(error.response?.status == 401)
      {
        return "PRESTA_ERROR_UNAUTHORIZED";
      }
      else
      {
        return error.message;
      }
    }
    else {
      return 'Presta Import Error';
    }
  }
}